/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{margin:0 16px}button[_ngcontent-%COMP%]{letter-spacing:normal;text-transform:none;color:#4a8ee0;padding:2px 0}button[_ngcontent-%COMP%]:hover{text-decoration:underline}svg-icon[_ngcontent-%COMP%]{fill:#4a8ee0;width:18px;height:18px;margin-right:10px}"];
export { styles as styles };
